import { ProductViewModel } from '~/lib/data-contract/auto-generated/product-model';
import { runtimeConfig } from '~/shared/utils/public-variables';
import { fetcher } from './fetcher';

export type ProductRequestPath = {
    franchiseAPIPath: string;
    productId: string;
    productColorId: string;
    headers?: HeadersInit;
    opts?: RequestInit;
};

export type ProductResponseType = ProductViewModel & { statusCode: number };

const { COMMERCE_URL } = runtimeConfig();
/**
 * Fetch product
 */
export async function fetchProduct({
    franchiseAPIPath,
    productId,
    productColorId,
    headers,
    opts,
}: ProductRequestPath): Promise<ProductResponseType> {
    const request = await fetcher<ProductViewModel>(
        `${COMMERCE_URL}/${franchiseAPIPath}/Product/${productId}/${productColorId}`,
        {},
        headers,
        opts
    );

    const response = await request.json();

    return { ...response, statusCode: request.status };
}
